import NextLink from "next/link";
import PropTypes from "prop-types";
import { Chakra } from "@airhelp/react-ui-components";

import { ArrowRightIcon } from "styles/icons";

const { Link } = Chakra;

const IconLink = ({ icon, text, href, prefetch, ...props }) => {
  const linkComponent = (
    <Link
      display="inline-flex"
      alignItems="center"
      color="primary.500"
      fontWeight="semibold"
      _hover={{
        textDecor: "none",
      }}
      href={href}
      {...props}
    >
      {text}
      {icon}
    </Link>
  );

  if (prefetch) {
    return (
      <NextLink href={href} passHref>
        {linkComponent}
      </NextLink>
    );
  }

  return linkComponent;
};

export default IconLink;

IconLink.propTypes = {
  prefetch: PropTypes.bool,
  href: PropTypes.string.isRequired,
  icon: PropTypes.node,
  text: PropTypes.string,
};

IconLink.defaultProps = {
  prefetch: false,
  icon: <ArrowRightIcon mt={0.5} ml={3} />,
  text: "",
};
